// Author Lin
// Date 2021-11-20 16:53:35

class MintalMesPrdSmeltingFurnacePowerFailureRecord {
    constructor({
            id = null,
            recordTime = '',
            locationId = '',
            locationName = '',
            shiftId = '',
            shiftName = '',
            furnaceId = '',
            furnaceName = '',
            stopTime = '',
            deliveryTime = '',
            outageDuration = '',
            causeOfFailure = '',
            recorderId = '',
            recorder = '',
            reviewerId = '',
            reviewer = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.recordTime = recordTime;
        this.locationId = locationId;
        this.locationName = locationName;
        this.shiftId = shiftId;
        this.shiftName = shiftName;
        this.furnaceId = furnaceId;
        this.furnaceName = furnaceName;
        this.stopTime = stopTime;
        this.deliveryTime = deliveryTime;
        this.outageDuration = outageDuration;
        this.causeOfFailure = causeOfFailure;
        this.recorderId = recorderId;
        this.recorder = recorder;
        this.reviewerId = reviewerId;
        this.reviewer = reviewer;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesPrdSmeltingFurnacePowerFailureRecord();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recordTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.recordTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'locationId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.locationId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'locationName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.locationName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'shiftId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.shiftId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'shiftName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.shiftName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'furnaceId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.furnaceId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'furnaceName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.furnaceName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'stopTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.stopTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'deliveryTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.deliveryTime',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'outageDuration',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.outageDuration',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'causeOfFailure',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.causeOfFailure',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recorderId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.recorderId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'recorder',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.recorder',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewerId',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.reviewerId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'reviewer',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.reviewer',
            sortable: true,
            isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        recordTimeRteFilter : '',
        recordTimeLteFilter : '',
        locationIdFilter : '',
        locationNameFilter : '',
        shiftIdFilter : '',
        shiftNameFilter : '',
        furnaceIdFilter : '',
        furnaceNameFilter : '',
        stopTimeRteFilter : '',
        stopTimeLteFilter : '',
        deliveryTimeRteFilter : '',
        deliveryTimeLteFilter : '',
        outageDurationFilter : '',
        causeOfFailureFilter : '',
        recorderIdFilter : '',
        recorderFilter : '',
        reviewerIdFilter : '',
        reviewerFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'recordTimeRteFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.recordTimeRte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'recordTimeLteFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.recordTimeLte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'locationNameFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.locationName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'imfMstLocation'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                    }
            },
            {
            key: 'shiftNameFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.shiftName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'imfMstShift'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                    }
            },
            {
            key: 'furnaceNameFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.furnaceName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstFurnace'
                ,correspondingField: 'furnaceName'
                ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                    }
            },
            {
            key: 'stopTimeRteFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.stopTimeRte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'stopTimeLteFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.stopTimeLte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'deliveryTimeRteFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.deliveryTimeRte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'deliveryTimeLteFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.deliveryTimeLte',
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'causeOfFailureFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.causeOfFailure',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'recorderFilter',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.recorder',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                    }
            },
            // {
            // key: 'reviewerFilter',
            // label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.filter.reviewer',
            // disabled: false,
            // form: {
            // type: 'entityModalSelect'
            //     ,entity: 'emAclUser'
            //     ,correspondingField: 'name'
            //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
            //         }
            // }
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'recordTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.recordTime',
            sortable: true,
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'locationName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.locationName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,required: true
                ,entity: 'imfMstLocation'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                    }
            },
            {
            key: 'shiftName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.shiftName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,required: true
                ,entity: 'imfMstShift'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                    }
            },
            {
            key: 'furnaceName',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.furnaceName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,required: true
                ,entity: 'mintalMesMstFurnace'
                ,correspondingField: 'furnaceName'
                ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                    }
            },
            {
            key: 'stopTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.stopTime',
            sortable: true,
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'deliveryTime',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.deliveryTime',
            sortable: true,
            disabled: false,
            form: {
            type: 'datetimepicker'
                    }
            },
            {
            key: 'causeOfFailure',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.causeOfFailure',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'recorder',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.recorder',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'emAclUser'
                ,correspondingField: 'name'
                ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                    }
            },
            // {
            // key: 'reviewer',
            // label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.reviewer',
            // sortable: true,
            // disabled: false,
            // form: {
            // type: 'entityModalSelect'
            //     ,entity: 'emAclUser'
            //     ,correspondingField: 'name'
            //     ,fieldsBindingByEntityModalSelected: '{"reviewerId":"id"}'
            //         }
            // },
            {
            key: 'remark',
            label: 'label.mintal.prd.mintalMesPrdSmeltingFurnacePowerFailureRecord.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesPrdSmeltingFurnacePowerFailureRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    